import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DprActivityModelReport } from '@report/models';
import { StaticMessage } from '@shared/enums';

@Component({
  selector: 'app-report-activities-with-inline-cd',
  templateUrl: './report-activities-with-inline-cd.component.html',
  styleUrls: ['./report-activities-with-inline-cd.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportActivitiesWithInlineCdComponent {
  @Input({ required: true }) activityModel: DprActivityModelReport;

  StaticMessage = StaticMessage;
}
